<ion-app>
  <ion-router-outlet></ion-router-outlet>
  @if (mockPanelComponentType(); as panelType) {
    <ng-container *ngComponentOutlet="panelType" />
  }
</ion-app>
